import classNames from 'classnames'
import React, { useRef, forwardRef, useImperativeHandle, useState, useEffect } from 'react'
import './index.less'

// 不支持中文输入法
export default forwardRef((props, ref) => {
  const { value = '', wrapClassName, wrapStyle, minHeight = 20, maxHeight = 80, withBorder, onChange, onInput, disabled, ...otherProps } = props
  const [isFocus, setIsFocus] = useState(false)
  const $textarea = useRef()
  useImperativeHandle(ref, () => ({
    $textarea: $textarea.current,
    clear: () => { $textarea.current.value = ''; resize() },
    value: () => $textarea.current.value,
    reset: () => { $textarea.current.value = value; resize() },
  }))
  useEffect(() => {
    $textarea.current.style.height = `${minHeight}px`
  }, [])
  useEffect(() => {
    $textarea.current.value = value
  }, [value])
  const resize = () => {
    if (!minHeight || !maxHeight) { return }
    $textarea.current.style.height = `${minHeight}px`
    if ($textarea.current.scrollHeight > maxHeight) {
      $textarea.current.style.height = `${maxHeight}px`
    } else {
      $textarea.current.style.height = `${$textarea.current.scrollHeight}px`
    }
  }
  const input = (e) => {
    resize()
    onChange && onChange(e)
    onInput && onInput(e)
  }
  const focus = (e) => {
    setIsFocus(true)
    props.onFocus && props.onFocus(e)
  }
  const blur = (e) => {
    setIsFocus(false)
    props.onBlur && props.onBlur(e)
  }

  return <div className={classNames('meinian-textarea', wrapClassName, { focus: isFocus, bordered: withBorder, disabled })} style={wrapStyle}>
    {props.prefix}
    <textarea
      ref={$textarea}
      {...otherProps}
      onChange={() => {}}
      onInput={input}
      onFocus={focus}
      onBlur={blur}
      disabled={disabled}
    />
    {props.suffix}
  </div>
})
